

























































































































































































































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
// eslint-disable-next-line import/no-extraneous-dependencies
import i18n from 'vue-i18n';
import { get, uniqBy, cloneDeep, isEqual, omit } from 'lodash';
import { User, Image, Space, Event, Page, MarketItem } from '@/types/GlobalTypes.ts';
import linkifyHtml from 'linkifyjs/html';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoEditorContent from '@/components/Molecules/co-editor-content/CoEditorContent.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import { AttachmentFile, normalizeAttachmentFile } from '@/utils/attachment';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoThumbnail from '../../Molecules/co-thumbnail/CoThumbnail.vue';
import CoCheckbox from '../../Atoms/co-checkbox/CoCheckbox.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoCard from '../../Molecules/co-card/CoCard.vue';
import CoComments from '../co-comments/coComments.vue';
import CoContentPreview from '../co-content-preview/CoContentPreview.vue';
import CoLinkPreview from '../co-link-preview/CoLinkPreview.vue';
import CoDropdown from '../../Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '../../Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoSlider from '../../Molecules/co-slider/CoSlider.vue';
import CoReactions from '../../Molecules/co-reactions/coReactions.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoConfirmation from '../../Molecules/co-confirmation/CoConfirmation.vue';
import CoUser from '../../Molecules/co-user/CoUser.vue';
import CoPoll from '../co-poll/CoPoll.vue';
import CoFile from '../CoFile/CoFile.vue';
import CoShare from '../co-share/CoShare.vue';

interface ContentFetch {
    Fetch: {
        ID: string;
        Type: string;
        Slug: string;
    };
}

interface Content {
    ID: string;
    Type: string;
    ImageURL: string;
    Title: string;
    Subtitle?: string;
    Label?: string;
    Starttime?: string;
    Endtime?: string;
}

interface Post {
    ID: string;
    Type: string;
    AuthorID?: string;
    Author: User;

    Text: string;
    Slug: string;
    CreatedAt: string;
    UpdatedAt: string;

    AnnouncedBy?: string;
    SentAnnouncement?: boolean;

    Images?: [Image];

    SpaceID?: string;
    Space?: Space;

    ParentContent?: ContentFetch | Event | Page | MarketItem;
    Parent?: ContentFetch | Event | Page | MarketItem;

    FeaturedContent?: ContentFetch | Event | Page | MarketItem;
    Featured?: ContentFetch | Event | Page | MarketItem;
    PinStatus?: number; // 1 = pinned, 0 = not pinned

    Variant?: string | number; // for undefined | 'post' | enum (2 = poll)
    // Poll data (proto)
    PollQuestion?: string;
    PollOptions?: Array<{
        ID: string;
        Text: string;
        VoteCount?: number;
        VoterIDsToDisplay?: string[];
        CurrentUserVoted?: boolean;
    }>;
    PollExpiresAt?: number | null;
    PollMultiSelect?: boolean;
    CurrentUserVoted?: boolean;
    ParentID?: string;
    ParentType?: number; // 0 = undefined, 1 = Event, 2 = Page, 3 = MarketItem
    Attachments?: AttachmentFile[];
    Reactions?: Record<string, unknown>;
}

// Keep the fields supported by realtime post modifications in one place, including poll results.
const REALTIME_POST_MUTABLE_FIELDS = [
    'Text',
    'Images',
    'Attachments',
    'Reactions',
    'UpdatedAt',
    'Variant',
    'PollQuestion',
    'PollOptions',
    'PollExpiresAt',
    'PollMultiSelect',
    'CurrentUserVoted',
];

export default {
    i18n: {
        messages: {
            en: {
                announce: 'Announce',
                announcementwarning: 'This will send a notification to every active member.',
                announcementsend: 'Send announcement',
                announced: 'Post has been announced',
                announcedby: 'Announced by {name}',
                forceannouncementwarning:
                    'If checked, the announcement will be sent to all community members regardless of their notification preferences.',
                forceannouncement: 'Ignore notification preferences',
                announcementnotificationinfo:
                    "Since Sep. 30th 2025 all active members receive notifications about new posts by default. So you don't need to announce posts manually.",
                pinposterror: 'Failed to pin the post',
                pinpostsuccess: 'Post was pinned successfully',
                unpinpostsuccess: 'Post was unpinned successfully',
            },
            de: {
                announce: 'Ankündigen',
                announcementwarning: 'Dies wird eine Benachrichtigung an alle aktiven Mitglieder senden.',
                announcementsend: 'Benachrichtigung senden',
                announced: 'Beitrag wurde angekündigt',
                announcedby: 'Angekündigt von {name}',
                forceannouncementwarning:
                    'Wenn aktiviert, wird die Ankündigung an alle Community-Mitglieder gesendet, unabhängig von ihren Benachrichtigungseinstellungen.',
                forceannouncement: 'Ignoriere Einstellungen für Benachrichtigungen',
                announcementnotificationinfo:
                    'Seit dem 30. Sep. 2025 erhalten alle aktiven Mitglieder standardmäßig Benachrichtigungen über neue Beiträge. Du musst Beiträge also nicht mehr manuell ankündigen.',
                pinposterror: 'Beitrag konnte nicht gepinnt werden',
                pinpostsuccess: 'Beitrag wurde erfolgreich gepinnt',
                unpinpostsuccess: 'Pin wurde erfolgreich vom Beitrag entfernt',
            },
        },
    },
    name: 'CoPost',
    components: {
        CoCard,
        CoThumbnail,
        CoShare,
        CoText,
        CoComments,
        CoContentPreview,
        CoLinkPreview,
        CoDropdown,
        CoDropdownItem,
        CoIcon,
        CoImage,
        CoSlider,
        CoReactions,
        CoSkeleton,
        CoConfirmation,
        CoCheckbox,
        CoEditorContent,
        CoUser,
        CoPoll,
        CoFile,
        CoButton,
    },
    props: {
        post: {
            type: Object as () => Post,
            default: () => ({}),
        },
        me: {
            type: Object as () => User,
        },
        loading: {
            // if true, the post is in loading state and displays as skeleton
            type: Boolean,
            default: false,
        },
        updated: {
            type: Boolean,
            default: false,
        },
        disableAnnouncement: {
            type: Boolean,
            default: false,
        },
        hideComments: {
            // if true, comments are hidden and not rendered at all
            type: Boolean,
            default: false,
        },
        hideContentPreview: {
            // if true, content preview is hidden and not rendered at all (used for parent content preview when it's the same as featured content)
            type: Boolean,
            default: false,
        },
        planSlug: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'full',
            validator: (value: string) => ['full', 'compact'].includes(value),
        },
        collapseComments: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isAdmin: !!(
                get(this.$store, 'state.me.Permissions') &&
                get(this.$store, 'state.me.Permissions').includes('space_admin')
            ),
            deleted: false,
            thisSpaceID: get(this.$store, 'state.space.ID', ''),

            forceAnnouncing: false,
            parentContent: null,
            collapsed: true,
            postContentHeight: 0,
            // comment collapse utility
            commentsCount: null, // count is length of  emitted by CoComments component event payload 'commentsLoaded'
            didIcomment: false,
            collapseCommentsLocal: this.collapseComments,
            reactionsVersion: 0,
            pollVoteRefreshes: 0,
        };
    },
    watch: {
        post: {
            handler() {
                this.updateLinksInText();
                if (this.updated) {
                    this.$emit('wasupdated');
                }
                this.$nextTick(() => {
                    this.setCollapseState();
                });
            },
            deep: true,
        },
        deleted(newVal) {
            if (newVal) {
                this.$emit('postDeleted', this.post);
            }
        },
        'post.ID': function (newPostID, previousPostID) {
            if (!newPostID || newPostID === previousPostID) return;
            EventBus.$off(`post_modify_${previousPostID}`, this.handleRealtimePostModified);
            EventBus.$on(`post_modify_${newPostID}`, this.handleRealtimePostModified);
        },
    },
    computed: {
        // eslint-disable-next-line vue/return-in-computed-property
        hideParentContent() {
            if (!this.post || !this.post.ParentID || !this.post.FeatureContentID) return false;
            // if parentid and FeatureContent are the same, hide parent content preview
            return isEqual(this.post.ParentID, this.post.FeatureContentID);
        },
        postAttachmentsForDisplay() {
            const attachments = this.post?.Attachments || [];
            return attachments.map((attachment) => normalizeAttachmentFile(attachment));
        },
        meLocal() {
            return this.me || get(this.$store, 'state.me', {});
        },
        canCreateFeedPost() {
            return this.$store.state.permissions && this.$store.state.permissions['feed.post'] === true;
        },
        isPinningEnabled() {
            return !this.post?.ParentID;
        },
        isAnnouncementEnabled() {
            return (
                this.isAdmin &&
                this.isMySpace &&
                ((this.post?.Type || '').toLowerCase() === 'post' || this.post.Type === 'project-update') &&
                !this.post.SentAnnouncement &&
                !this.disableAnnouncement &&
                !this.isParentContentPrivate
            );
        },
        isParentContentPrivate() {
            if (!this.parentContent) return false;
            if (this.parentContent.Type === 'project' && !this.parentContent.Published) return true;
            return false;
        },
        isMySpace() {
            return get(this.$store, 'state.space.ID', '') === get(this, 'post.SpaceID');
        },
        isPoll() {
            // supports legacy string 'poll' and enum value 2 or presence of poll fields
            const v = this.post?.Variant;
            const isVariantPoll = v === 'poll' || v === 2 || v === '2';
            const hasFields = !!(this.post?.PollQuestion || (this.post?.PollOptions || []).length > 0);
            return isVariantPoll || hasFields;
        },
        initialSelection() {
            return (this.post?.PollOptions || [])
                .filter((o) => !!o.CurrentUserVoted)
                .map((o) => o.ID)
                .filter(Boolean);
        },
        postURL() {
            if (this.post.Slug) {
                return `${window.location.origin}/${this.post.Type}/${this.post.Slug}`;
            }
            return `${window.location.origin}/${this.post.Type}/${this.post.ID}`;
        },
        canEdit() {
            if (!this.meLocal?.ID) return false;
            return this.meLocal.ID === this.post.Author.ID;
        },
        hasImages() {
            if (!this.post) return false;
            if (!this.post.Images) return false;
            if (!Array.isArray(this.post.Images)) return false;
            if (this.post.Images.length === 0) return false;
            return true;
        },
        // returns either the featured content from the prefilled content or links found that is suitable for featuring based on domain
        featuredContent() {
            if (!this.post) return null;

            // check for featured content in prefilled content first
            const contentId = this.post?.FeatureContentID || null;
            const contentType = this.post?.FeaturedContentType || null;
            const normalizedType = this.mapFeaturedContentType(contentType);
            if (contentId && normalizedType) {
                return {
                    ID: contentId,
                    Type: normalizedType,
                };
            }

            // if there is no prefilled featured content, and the post has images, do not show link preview as featured content it will be shown as a link preview instead  and return null for featured content to avoid showing duplicate link preview in the rich media area
            if (this.hasImages) return null;

            if (!this.post.Text) return null;

            // if no featured content, check for links in the post content that are suitable for featuring
            let links = [];
            if (this.post.Text) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(this.post.Text, 'text/html');
                links = Array.from(doc.getElementsByTagName('a')).map((link) => link.href);
            }
            links = uniqBy(links, (link) => {
                try {
                    const url = new URL(link);
                    return url.href;
                } catch (e) {
                    return link;
                }
            });

            // Direct store access keeps Vue tracking the space domain dependency reactively.
            const spaceDomainName = this.$store?.state?.space?.DomainName;
            links = links.filter((link) => {
                try {
                    const url = new URL(link);
                    return url.host && url.host === spaceDomainName;
                } catch (e) {
                    return false;
                }
            });

            if (links.length > 0) {
                return {
                    Slug: links[0],
                    Link: links[0],
                };
            }
            return null;
        },
        //  returns first link found in the post content that are not suitable for featuring based on domain
        linkToDisplay() {
            if (this.featuredContent && this.hasImages) return null;
            if (!this.post || this.post.Text === '') return null;

            let links = [];
            if (this.post.Text) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(this.post.Text, 'text/html');
                links = Array.from(doc.getElementsByTagName('a')).map((link) => link.href);
            }
            links = uniqBy(links, (link) => {
                try {
                    const url = new URL(link);
                    return url.href;
                } catch (e) {
                    return link;
                }
            });

            const featured = this.featuredContent ? this.featuredContent.Link : null;
            links = links.filter((link) => {
                if (featured && link === featured) {
                    return false;
                }
                return true;
            });
            return links.length > 0 ? links[0] : null;
        },
        announcedByName() {
            if (typeof this.post?.AnnouncedBy === 'string') return this.post.AnnouncedBy;
            return this.post?.AnnouncedBy?.Name || this.$t('labels.unknown');
        },
    },
    mounted() {
        EventBus.$on(`post_modify_${this.post.ID}`, this.handleRealtimePostModified);
        this.$nextTick(() => {
            this.updateLinksInText();
            if (this.updated) this.$emit('wasupdated');
            this.setCollapseState();
        });
    },
    beforeDestroy() {
        EventBus.$off(`post_modify_${this.post.ID}`, this.handleRealtimePostModified);
    },
    methods: {
        get,
        cloneDeep,
        handleRealtimePostModified(updatedPost) {
            if (!updatedPost || String(updatedPost.ID || updatedPost.PostID) !== String(this.post.ID)) return;
            const pollOptionsChanged =
                Array.isArray(updatedPost.PollOptions) &&
                !isEqual(
                    (this.post.PollOptions || []).map((option) => omit(option, 'CurrentUserVoted')),
                    updatedPost.PollOptions.map((option) => omit(option, 'CurrentUserVoted'))
                );

            // Keep the parent-owned post object current so all supported rendered fields update together.
            /* eslint-disable vue/no-mutating-props -- Realtime changes intentionally synchronize the shared post source. */
            REALTIME_POST_MUTABLE_FIELDS.forEach((field) => {
                if (!Object.prototype.hasOwnProperty.call(updatedPost, field)) return;

                if (field === 'PollOptions' && !pollOptionsChanged) {
                    // Ignore the non-user-scoped vote flag when no poll result data changed.
                    return;
                }

                if (field === 'PollOptions') {
                    const currentUserVotes = new Map(
                        (this.post.PollOptions || []).map((option) => [option.ID, option.CurrentUserVoted])
                    );
                    // Vote SSE payloads can omit option text; merge them so labels never disappear before the refetch.
                    this.$set(
                        this.post,
                        'PollOptions',
                        this.mergePollOptions(updatedPost.PollOptions).map((option) => ({
                            ...option,
                            CurrentUserVoted: currentUserVotes.get(option.ID) || false,
                        }))
                    );
                    return;
                }

                if (field === 'PollQuestion' && !updatedPost.PollQuestion && this.post.PollQuestion) {
                    // A vote event must not blank a required question when its partial SSE payload serializes it as empty.
                    return;
                }

                if (field === 'Images') {
                    const images = Array.isArray(updatedPost.Images) ? updatedPost.Images : [];
                    this.$set(
                        this.post,
                        'Images',
                        images.map((image) => (image?.ImageURL ? cloneDeep(image) : { ImageURL: image?.url || image }))
                    );
                    return;
                }

                if (field === 'Attachments') {
                    this.$set(
                        this.post,
                        'Attachments',
                        Array.isArray(updatedPost.Attachments) ? cloneDeep(updatedPost.Attachments) : []
                    );
                    return;
                }

                if (field === 'Reactions') {
                    // Replace the complete reaction map so CoReactions immediately reconciles removals as well as additions.
                    this.$set(this.post, 'Reactions', cloneDeep(updatedPost.Reactions || {}));
                    // CoReactions keeps a local optimistic copy, so remount it with the server-authoritative map.
                    this.reactionsVersion += 1;
                    return;
                }

                this.$set(this.post, field, cloneDeep(updatedPost[field]));
            });

            if (!Object.prototype.hasOwnProperty.call(updatedPost, 'Reactions')) {
                // The SSE serializer omits the reaction map after the final reaction is removed.
                this.$set(this.post, 'Reactions', {});
                this.reactionsVersion += 1;
            }
            /* eslint-enable vue/no-mutating-props */

            if (pollOptionsChanged) {
                this.refreshPollVoteState();
            }
        },
        async refreshPollVoteState() {
            const postID = this.post.ID;
            this.pollVoteRefreshes += 1;

            try {
                // The realtime payload is not user-scoped, so retrieve the authoritative vote state for this user.
                const refreshedPost = await this.$store.dispatch('getPostByID', postID);
                if (this.post.ID !== postID || !Array.isArray(refreshedPost?.PollOptions)) return;
                if (
                    isEqual(this.post.PollOptions, refreshedPost.PollOptions) &&
                    this.post.PollQuestion === refreshedPost.PollQuestion
                ) {
                    return;
                }

                /* eslint-disable vue/no-mutating-props -- Synchronize the shared post source with its authenticated response. */
                this.$set(this.post, 'PollOptions', this.mergePollOptions(refreshedPost.PollOptions));
                if (refreshedPost.PollQuestion) this.$set(this.post, 'PollQuestion', refreshedPost.PollQuestion);
                /* eslint-enable vue/no-mutating-props */
            } catch (error) {
                console.error('Error refreshing poll vote state:', error);
            } finally {
                // Keep options disabled until every outstanding authenticated poll refresh has completed.
                this.pollVoteRefreshes -= 1;
            }
        },
        mergePollOptions(incomingOptions) {
            // Keep Map.get typed as a poll option so TypeScript permits spreading the saved fields.
            const existingOptions = new Map<string, NonNullable<Post['PollOptions']>[number]>(
                (this.post.PollOptions || []).map((option) => [option.ID, option])
            );
            // Vote snapshots omit zero-value fields; reset results while retaining omitted option labels.
            return incomingOptions.map((option) => ({
                ...cloneDeep(existingOptions.get(option.ID) || {}),
                ...cloneDeep(option),
                VoteCount: option.VoteCount || 0,
                CurrentUserVoted: !!option.CurrentUserVoted,
                VoterIDsToDisplay: cloneDeep(option.VoterIDsToDisplay || []),
            }));
        },
        shareInPost() {
            if (!this.canCreateFeedPost) return;
            EventBus.$emit('STARTNEWPOST', {
                content: `${this.postURL}<br>`,
                shareActivity: {
                    contentType: 'post',
                    contentSlug: this.post.Slug,
                    contentURL: this.postURL,
                    contentID: this.post?.ID,
                },
            });
        },
        commentsLoaded(comments) {
            if (!comments) {
                this.commentsCount = 0;
                this.didIcomment = false;
                return;
            }
            this.commentsCount = comments?.length || 0;
            const myComment = comments.find((c) => c?.AuthorID === this.meLocal?.ID);
            this.didIcomment = !!myComment?.ID;
        },
        goToPostUrl() {
            if (this.loading) return;
            if (this.post?.Slug && this.$router) {
                this.$router.push(`/post/${this.post.Slug}`);
            } else {
                console.warn('Cannot navigate to post URL, router or URL missing');
            }
        },
        setCollapseState() {
            // calculate post content height for collapse
            const contentRef = this.$refs[`postContent${this.post.ID}`];
            if (contentRef && contentRef instanceof HTMLElement) {
                this.postContentHeight = contentRef.scrollHeight;
                if (contentRef.scrollHeight <= 150) {
                    this.collapsed = false;
                } else {
                    this.collapsed = true;
                }
            }
        },
        handleReadMoreClick() {
            if (!this.collapsed) return;
            this.collapsed = false;
            this.recordActivity('post_read_more', 'read_more_click', 'post_read_more');
        },

        handleShowAllCommentsClick() {
            this.collapseCommentsLocal = false;
            this.recordActivity('post_comments_show_all', 'feature_click', 'post_comments_show_all');
        },
        expandCommentInput() {
            this.$nextTick(() => {
                const { comments } = this.$refs;
                if (comments) {
                    comments.expandEditor();
                }
                if (comments && comments.$el && typeof comments.$el.scrollIntoView === 'function') {
                    comments.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        recordActivity(funnel = 'post_read_more', step = 'feature_click', feature_key = 'post_read_more') {
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            axios
                .post('/me/activity/funnel', {
                    funnel,
                    step,
                    feature_key,
                    location,
                    full_path: fullPath,
                    parameters: {
                        post_id: this.post?.ID,
                        post_slug: this.post?.Slug,
                    },
                })
                .catch((error) => {
                    console.error('Failed to record activity', error);
                });
        },

        voteAdded(payload) {
            this.setCurrentUserPollVote(payload.OptionID, true);
            axios({
                method: 'POST',
                url: '/post/poll/vote',
                data: {
                    post_id: this.post?.ID,
                    option_id: payload.OptionID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // update local poll data
                    EventBus.$emit('INFO', {
                        Message: this.$t('polls.pollvoteadded'),
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('polls.pollvoteadderror'),
                    });
                    console.error(error);
                });
        },
        voteRemoved(payload) {
            this.setCurrentUserPollVote(payload.OptionID, false);
            axios({
                method: 'DELETE',
                url: '/post/poll/vote',
                data: {
                    post_id: this.post?.ID,
                    option_id: payload.OptionID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // update local poll data
                    EventBus.$emit('INFO', {
                        Message: this.$t('polls.pollvoteremoved'),
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('polls.pollvoteremoveerror'),
                    });
                    console.error(error);
                });
        },
        setCurrentUserPollVote(optionID, voted) {
            const option = this.post?.PollOptions?.find((pollOption) => pollOption.ID === optionID);
            if (!option || !!option.CurrentUserVoted === voted) return;

            // Mirror the optimistic count and voters too, so the parent watcher cannot restore stale results.
            /* eslint-disable vue/no-mutating-props */
            this.$set(option, 'CurrentUserVoted', voted);
            this.$set(option, 'VoteCount', Math.max(0, (option.VoteCount || 0) + (voted ? 1 : -1)));
            if (this.me?.ID) {
                const voterIDs = (option.VoterIDsToDisplay || []).filter((id) => id !== this.me.ID);
                if (voted) voterIDs.push(this.me.ID);
                this.$set(option, 'VoterIDsToDisplay', voterIDs);
            }
            /* eslint-enable vue/no-mutating-props */
        },
        showPaywall() {
            EventBus.$emit('PAYWALL', {
                feature: 'pin-post',
            });
        },
        parentContentLoaded(content) {
            this.parentContent = content;
        },
        // returns height for the slider based on width of container to keep aspect ratio 16:9
        sliderHeight() {
            if (!this.$refs.slider_container) return '486px';
            return `${((this.$refs.slider_container as HTMLElement).clientWidth * 9) / 16}px`;
        },
        updateLinksInText() {
            // linkify the post content, important for backwards compatibility
            const input = get(this.post, 'Text', '');
            if (!input) return;

            this.post.Text = linkifyHtml(input, {
                nl2br: true, // optional
                className: 'link',
                defaultProtocol: 'https',
                ignoreTags: ['a', 'pre', 'code', 'span'],
                validate: {
                    mention(value) {
                        return false;
                    },
                    hashtag(value) {
                        return false;
                    },
                },
            });
        },

        mapFeaturedContentType(type: any) {
            if (type === null || type === undefined) return null;
            const normalized = Number(type);
            const map: Record<number, string> = {
                1: 'event',
                2: 'project',
            };
            if (!Number.isNaN(normalized) && map[normalized]) {
                return map[normalized];
            }
            if (typeof type === 'string') {
                const lower = type.toLowerCase();
                if (['event', 'project'].includes(lower)) return lower;
            }
            return null;
        },
        copyLink() {
            EventBus.$emit('INFO', {
                Message: this.$t('messages.copiedtoclipboard'),
            });
            navigator.clipboard.writeText(this.postURL);
        },
        postDelete(asAdmin = false) {
            const delPost = this.post;
            // remove images from delPost, so backend doesn't break because of different object structure
            delete delPost.Images;
            delete delPost.AnnouncedBy;
            axios({
                method: 'DELETE',
                url: asAdmin ? '/admin/post' : '/post',
                data: delPost,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.deleted = true;
                    this.$emit('postDeleted', this.post);
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: 'Failed to delete the post',
                    });
                    console.error(error);
                });
        },
        async pinPost() {
            if (!this.$store.state.limits.Config.pin_post) {
                this.showPaywall();
                return;
            }

            try {
                // pin the post
                await axios.post(`/post/pin/${this.post.ID}`);
                // emit event to parent component to refresh pinned posts
                this.$emit('postPinChanged', {
                    ...this.post,
                    PinStatus: 1,
                });
                // show success message
                EventBus.$emit('INFO', {
                    Message: this.$t('pinpostsuccess'),
                });
            } catch (error) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('pinposterror'),
                });
                console.error(error);
            }
        },
        async unpinPost() {
            try {
                // pin the post
                await axios.delete(`/post/pin/${this.post.ID}`);
                // emit event to parent component to refresh pinned posts
                this.$emit('postPinChanged', {
                    ...this.post,
                    PinStatus: 0,
                });
                // show success message
                EventBus.$emit('INFO', {
                    Message: this.$t('unpinpostsuccess'),
                });
            } catch (error) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('pinposterror'),
                });
                console.error(error);
            }
        },

        sendAnouncement() {
            if (this.planSlug === 'free') {
                EventBus.$emit('PAYWALL', {
                    feature: 'announce-post',
                    plan: this.planSlug || 'unknown',
                });
                return;
            }
            let url = `/admin/community/post/send-announcement/${this.post.ID}`;

            if (this.forceAnnouncing) {
                url += '?force=true';
            }

            axios({
                method: 'POST',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: 'Announcement was successfuly sent',
                        Details: null,
                    });
                    this.post = {
                        ...this.post,
                        SentAnnouncement: true,
                        AnnouncedBy: get(this.$store, 'state.me.Name', ''),
                    };
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: 'An error occured. The announcement was not sent',
                        Details: null,
                    });
                    console.log(error);
                });
        },
    },
};
